<template>
    <ResultsNetworkBanner bannerType="info" :header="(isTypeDoctor ? 'In network' : '')">
        <span v-if="isTypeDoctor">
            The provider you selected is contracted for the specific location, so your provider’s name and full address must match. <span> Check your <a href="/my/plan-overview/coverage.html" :data-card-rank="rank">coverage details</a> to learn more.</span>
        </span>
        <span v-if="isTypeMedical">
            <b>Some doctors and clinicians here are in network, but others aren’t.</b> Use the doctor search to confirm the specific person or <a href="/my/contact/">call Member Services</a> to confirm before making an appointment. <span> Check your <a href="/my/plan-overview/coverage.html" :data-card-rank="rank">coverage details</a> to learn more.</span>
        </span>
    </ResultsNetworkBanner>
</template>
    
<script setup>
const {  context } = useFCPModel()

const isTypeDoctor = context.value?.type === 'doctor'
const isTypeMedical = context.value?.type === 'medical'

const props = defineProps({
        result: Object,
        rank: Number
    })

</script>